import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'

import OrganizationInformation from './OrganizationInformation'
import RegistrationDetails from './RegistrationDetails'

const FirstPage = ({ fields, selects, dynamicOptions, onTranslateAltRequest }) => (
  <GridContainer smallPadding>
    <Grid>
      <OrganizationInformation
        fields={fields}
        selects={selects}
        dynamicOptions={dynamicOptions}
        onTranslateAltRequest={onTranslateAltRequest}
      />

      <RegistrationDetails fields={fields} />
    </Grid>
  </GridContainer>
)

export default FirstPage
